var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_market") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-332, -79)",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(333, 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3830124,27.1519847 C20.0584208,27.1533526 25.4687993,21.7460273 25.4674314,15.0743853 C25.4660629,8.40274329 20.053466,2.99319967 13.3780576,2.99183119 C9.09580292,2.99095375 5.33413132,5.21585323 3.1877258,8.5724647",
    id: "\\u692D\\u5706\\u5F62",
    strokeLinecap: "round",
    transform: "translate(14.3276, 15.0719) rotate(162) translate(-14.3276, -15.0719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6053233,0.023144056 C21.0317965,0.20417042 24.3410187,1.38990494 26.53299,3.58034761 C28.6132356,5.6591425 29.7567104,8.71228253 29.9634145,12.7397677 L29.9634374,12.7397665 C30.00565,13.5671175 29.3691695,14.272038 28.5418186,14.3142506 C28.5173746,14.3154977 28.4929038,14.3161464 28.468428,14.3161961 L17.4707144,14.3161992 C16.4766019,14.3161992 15.6707145,13.5103117 15.6707145,12.5161992 L15.67072,0.919228627 C15.6724674,0.422175437 16.0768252,0.0206507465 16.5738784,0.0223981298 C16.5843641,0.0224349924 16.5948485,0.0226551059 16.6053266,0.0230583693 Z",
    id: "\\u77E9\\u5F62"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarket);
export default __webpack_public_path__ + "static/media/icon_market.751efb713db9b399b9dda4c42b18b96a.svg";
export { ForwardRef as ReactComponent };